import axiosInstance from 'utils/axiosInstance';
import {
  changeFormStatusStep,
  FormStatus,
  reorderFormStatus,
} from '../types/statusTypes';

export const getFormStatus = async (formId: number) => {
  const { data } = await axiosInstance.get<ApiResponse<FormStatus[]>>(
    `api/Forms/Statuts/${formId}`,
  );
  return data;
};

export const editFormStatus = async (statusInfo: FormStatus) => {
  const { data } = await axiosInstance.post<ApiResponse<FormStatus>>(
    'api/Forms/EditStatue',
    statusInfo,
  );
  return data;
};

export const deleteFormStatus = async (statusId: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<FormStatus>>(
    `api/Forms/DeleteStatut/${statusId}`,
  );
  return data;
};

export const changeOrderFormStatus = async (statusInfo: reorderFormStatus) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/Forms/ChangeOrderStatut',
    statusInfo,
  );
  return data;
};

export const changeStepFormStatus = async (
  statusInfo: changeFormStatusStep,
) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/Forms/ChangeStepStatut',
    statusInfo,
  );
  return data;
};

export const changeStatutForm = async (formInfo: {
  formId: number;
  state: boolean;
}) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/Forms/ChangeStateStatut',
    formInfo,
  );
  return data;
};

export const changeResponseStatus = async (statusInfo: {
  id: number;
  statutId: number;
}) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/Forms/ChangeStatutResponse',
    statusInfo,
  );
  return data;
};
